// extracted by mini-css-extract-plugin
module.exports = {"FooterSegment":"Footer_FooterSegment__1cAf0"};